import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import MediaQuery from 'react-responsive';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import get from 'lodash/get';
import Avatar from '../Avatar';
import HiddenLink from './Components/HiddenLink';
import UserLink from './Components/UserLink';
import LogoutBtn from './Components/LogoutBtn';
import AssignBtn from './Components/AssignBtn';
import LoginBtn from './Components/LoginBtn';
import MenuItems from './Components/MenuItems';
import AppNotificationsBtn from './Components/AppNotificationsBtn';
import AssignMenuList from './Components/AssignMenuList';
import { BREAKPOINT } from '../../constants/styles';
import { PROFILE } from '../../constants/routes';
import { AUTH } from '../../constants/strings';
import styles from './index.styl';

const Menu = ({
  items,
  isOpened,
  user,
  isProvider,
  isLoggedIn,
  isCommunityPreview,
  intl: { formatMessage },
  openJoinPopup,
  teamsMenuItems,
  isTeamMemberProvider,
  loggedUserId,
}) => {
  const { displayableName, id, primaryProviderProfile, username } = user || {};
  const role = primaryProviderProfile ? 'provider' : 'patient';
  const profileLink = id === loggedUserId ? `/${PROFILE}/${id}/${role}` : null;
  const name = displayableName || username;

  const openJoinDialog = () => openJoinPopup({ content: 'join' });
  const showCondition = isMobile => !isMobile || (isMobile && isOpened);
  const avatar = (
    <Avatar children={name} size={32} src={get(user, 'avatar.thumbMiddle')} />
  );

  return (
    <div styleName="menu">
      <If condition={isLoggedIn || isCommunityPreview}>
        <ul styleName={classNames('nav', { 'nav--grow': isCommunityPreview })}>
          {isCommunityPreview && (
            <div styleName="overlay" onClick={openJoinDialog} />
          )}
          <MenuItems items={items} />
          <LoginBtn
            visible={isCommunityPreview && !isLoggedIn}
            formatMessage={formatMessage}
            openJoinPopup={openJoinPopup}
          />
        </ul>
      </If>
      <If condition={!isCommunityPreview}>
        <div styleName="separator" className="g-shownOnDesktop" />
      </If>
      <If condition={isLoggedIn}>
        <MediaQuery minWidth={BREAKPOINT + 1}>
          <Fragment>
            <AppNotificationsBtn isProvider={isProvider} />
            <AssignBtn isProvider={isProvider} />
          </Fragment>
        </MediaQuery>
        <MediaQuery maxWidth={BREAKPOINT}>
          <AssignMenuList
            isProvider={isProvider}
            renderItems={assignOptions =>
              assignOptions.map(({ id: optId, onClick, text }) => (
                <li styleName="item" id={optId} onClick={onClick} key={optId}>
                  <span styleName="link">{text}</span>
                </li>
              ))
            }
          />
        </MediaQuery>
        <MediaQuery maxWidth={BREAKPOINT}>
          {isMobile => {
            if (showCondition(isMobile)) {
              return (
                <UserLink
                  href={profileLink}
                  displayableName={name}
                  avatar={avatar}
                  teamsMenuItems={teamsMenuItems}
                  isTeamMember={isTeamMemberProvider}
                  isMobile={isMobile}
                />
              );
            }

            return (
              <HiddenLink href={`/${PROFILE}`} {...{ isMobile, isOpened }} />
            );
          }}
        </MediaQuery>
        <MediaQuery maxWidth={BREAKPOINT}>
          {isMobile => {
            const text = isOpened ? formatMessage(AUTH.actions.logout) : null;

            return (
              <If condition={showCondition(isMobile)}>
                <LogoutBtn {...{ text }} />
              </If>
            );
          }}
        </MediaQuery>
      </If>
    </div>
  );
};

Menu.propTypes = {
  items: PropTypes.array.isRequired,
  isOpened: PropTypes.bool.isRequired,
  user: PropTypes.object,
  isProvider: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isCommunityPreview: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  openJoinPopup: PropTypes.func,
  teamsMenuItems: PropTypes.array,
  isTeamMemberProvider: PropTypes.bool,
  loggedUserId: PropTypes.number,
};

Menu.defaultProps = {
  user: {},
  isProvider: false,
  isLoggedIn: false,
  isCommunityPreview: false,
  openJoinPopup: false,
};

export default injectIntl(CSSModules(Menu, styles, { allowMultiple: true }));



// WEBPACK FOOTER //
// ./src/components/Header/Menu.jsx